import React from 'react';
import styled, {css} from 'styled-components';
import {mobileMediaQuery, sizes} from './../../styles';

import {colors} from './../../styles';

const Container = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 150px;
    height: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    
    font-size: 0.9rem;
    text-transform: uppercase;
    font-weight: 600;
    text-decoration: none;
    box-sizing: border-box;
    cursor: pointer;
    ${props => props.active && `background-color: white`}
    ${props => (props.flex ? `flex: ${props.flex}` : 'flex: 1')}
    ${props => props.margin && `margin: ${props.margin}`}
    padding: ${props => (props.padding ? props.padding : '.5rem 0')};
    ${props => props.minWidth && `min-width: ${props.minWidth}`}
    transition: background-color 0.25s ease-in-out;
    ${props => props.width && `width: ${props.width}`}
    color: ${props => (props.active ? 'black' : 'white')};

    span {
        font-size: 15px;
        line-height: 16px;
        font-weight: bold;
    }
    @media (min-width: ${sizes.xlarge}) {
        width: 132px;
    }

    svg {
        max-height: fill-available;
        height: 32px;

        &:not(:only-child) {
            margin-bottom: 8px;
        }
    }
    overflow: hidden;

    ${props => props.transparent && `background-color: transparent;`}

    ${props =>
        props.dark &&
        css`
            color: #000;

            svg g,
            svg use {
                fill: #000;
            }
        `}

    ${props =>
        props.cnito &&
        css`
            span {
                font-family: 'Rodger';
                font-weight: bold;
            }
        `}

    ${props =>
        props.transparent &&
        props.active &&
        css`
            color: ${colors.pink};
            svg g,
            svg use {
                fill: ${colors.pink};
            }
        `}

`;

const Gradient = styled.div`
    position: relative;
    bottom: 0;
    width: 100%;
    z-index: 1;
    height: 4px;
    background: transparent;
    margin-top: 6px;

    ${props =>
        !props.cnito &&
        props.active &&
        `background: linear-gradient(
        90deg, 
        #00AEEF 0%, 
        #FFD93F 32.81%, 
        #FFD93F 68.75%, 
        #EC008C 100%
        );`}

    ${mobileMediaQuery} {
        margin-top: 0px;
    }
`;

const Icon = styled.img`
    max-height: fill-available;
    object-fit: contain;

    &:not(:only-child) {
        margin-bottom: 8px;
    }
`;

const BigButton = ({
    value,
    icon,
    children,
    iconWidth,
    iconHeight,
    transparent,
    dark,
    cnito,
    ...props
}) => {
    return (
        <Container
            {...props}
            transparent={transparent}
            dark={dark}
            icon={icon}
            cnito={cnito}
            padding={!cnito ? '0px' : undefined}
        >
            {icon && <Icon width={iconWidth} height={iconHeight} src={icon} />}
            {children && children}
            {value && <span>{value}</span>}
            <Gradient {...props} />
        </Container>
    );
};

export default BigButton;
